import React from "react";
import { FormattedMessage } from "react-intl";
import WizardConflictPopupCartItem from "../wizardConflictPopupCartItem";

const ReviewConflicts = ({categorizedConflictingCartItems}) => {

  const { itemsToRemove, itemsToUpdate } = categorizedConflictingCartItems;

  return (
    <>
      <p className="ui-popup__body-subtitle">
        <FormattedMessage id="confirmPopup.updateWizardIncompatibleItemsText" />
      </p>

      {itemsToUpdate.length > 0 && (
        <div className="mt-6">
          <div className="ui-popup__list-title flex items-center gap-2 mb-3">
            <div className="w-6 h-6 rounded-full bg-primary flex items-center justify-center flex-shrink-0">
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
            </div>
            <h3 className="text-base font-semibold u-m-0">
              <FormattedMessage id="reviewConflicts.itemsToUpdate" defaultMessage="Items to Update" />
            </h3>
            <span className="text-base font-semibold ">({itemsToUpdate.length})</span>
          </div>

          <ul className="apply-popup-list space-y-2">
            {itemsToUpdate.map(({ cartItem }) => {
              if (cartItem.bundleParentId) {
                return null;
              }
              return <WizardConflictPopupCartItem key={cartItem.id} cartItem={cartItem} />;
            })}
          </ul>
        </div>
      )}

      {itemsToRemove.length > 0 && (
        <div className="mt-6">
          <div className="flex items-center gap-2 mb-3 ">
            <div className="w-6 h-6 rounded-full bg-[#D0021B] flex items-center justify-center flex-shrink-0">
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </div>
            <h3 className="text-base font-semibold u-m-0">
              <FormattedMessage id="reviewConflicts.itemsToRemove" defaultMessage="These items will be removed from your cart." />
            </h3>
            <span className="text-base font-semibold ">({itemsToRemove.length})</span>
          </div>

          <ul className="apply-popup-list space-y-2 color-red">
            {itemsToRemove.map(({ cartItem }) => {
              if (cartItem.bundleParentId) {
                return null;
              }
              return <WizardConflictPopupCartItem key={cartItem.id} cartItem={cartItem} />;
            })}
          </ul>
        </div>
      )}

      {itemsToRemove.length === 0 && itemsToUpdate.length === 0 && (
        <div className="text-center py-8 color-gray4 bold">
          <FormattedMessage id="reviewConflicts.noConflicts" defaultMessage="No conflicting items found" />
        </div>
      )}
    </>
  );
};

export default ReviewConflicts;
